var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 128 128",
    height: 128,
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e84142",
    d: "M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M86.576 65.663c2.217-3.83 5.795-3.83 8.013 0l13.808 24.239c2.217 3.83.403 6.954-4.032 6.954H76.548c-4.384 0-6.198-3.124-4.032-6.954l14.06-24.239zM59.868 18.998c2.217-3.83 5.745-3.83 7.962 0l3.074 5.543 7.257 12.75c1.764 3.628 1.764 7.912 0 11.54l-24.34 42.18c-2.217 3.427-5.896 5.594-9.978 5.846H23.635c-4.435 0-6.249-3.074-4.031-6.954l40.265-70.904z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.1840d944d506eea44881850de25b1588.svg";
export { ForwardRef as ReactComponent };